// @flow

import styled, { css } from 'styled-components';
import { inPixels } from '../commons/media-size';

export const Hide = styled.div`
  ${props => props.from && css`
    @media (min-width: ${inPixels(props.from)}px) {
      display: none;
    }
  `}

  ${props => props.to && css`
    @media (max-width: calc(${inPixels(props.to)}px - 1px)) {
      display: none;
    }
  `}
`;
